export const industryMap = {
  farming: {
    name: "Farming",
    type: "resource",
    image: "/skills/farming.png",
    dataTypes: {
      crop: {
        template: {
          Item: { id: "item.id", image: "item.image", name: "item.name" },
          Level: "item.crop.plantingLvl",
          Tier: "item.tier",
          Energy: {
            formula: "(plantingEnergy - harvestEnergy - 1) * -1",
            plantingEnergy: "item.crop.plantingEnergy",
            harvestEnergy: "item.crop.harvestEnergy",
          },
          "Grow Time": "item.crop.growTime",
          Exp: "item.crop.harvestExp",
          "Exp/Energy": {
            formula: "harvestExp / totalEnergy",
            harvestExp: "item.crop.harvestExp",
            totalEnergy: {
              formula: "(plantingEnergy - harvestEnergy - 1) * -1",
              plantingEnergy: "item.crop.plantingEnergy",
              harvestEnergy: "item.crop.harvestEnergy",
            },
          },
          Result: {resultId: "item.crop.resultId", resultName: "item.crop.result"},
        },
      },      
    },
  },
  farming_recipes: {
    name: "Farming",
    type: "crafting",
    industries: { windmill: "Windmill", farming: "Farming" },
    image: "/skills/farming.png",
    dataTypes: {
      crop: {
        template: {
          Item: { id: "item.id", image: "item.image", name: "item.name" },
          Level: "item.crop.plantingLvl",
          Tier: "item.tier",
          Energy: {
            formula: "(plantingEnergy - harvestEnergy - 1) * -1",
            plantingEnergy: "item.crop.plantingEnergy",
            harvestEnergy: "item.crop.harvestEnergy",
          },
          "Grow Time": "item.crop.growTime",
          Exp: "item.crop.harvestExp",
          "Exp/Energy": {
            formula: "harvestExp / totalEnergy",
            harvestExp: "item.crop.harvestExp",
            totalEnergy: {
              formula: "(plantingEnergy - harvestEnergy - 1) * -1",
              plantingEnergy: "item.crop.plantingEnergy",
              harvestEnergy: "item.crop.harvestEnergy",
            },
          },
          Recipe: null,
          Industry: { value: "Soil" },
          Result: "item.crop.result",
        },
      },
      recipes: {
        path: "item.recipes[*]",
        filter: "recipe.expType == 'Farming'",
        template: {
          Item: { id: "recipe.id", image: "recipe.image", name: "recipe.name" },
          Level: "recipe.level",
          Tier: "recipe.tier",
          Energy: "recipe.energy",
          "Grow Time": "recipe.craftingTime",
          Exp: "recipe.exp",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "recipe.exp",
            energy: "recipe.energy",
          },
          Recipe: {
            ingredients: "recipe.ingredients.map(ing => ({image: ing.image, name: ing.name, quantity: ing.quantity}))",
          },
          Industry: "recipe.expCategory",
          Result: null,
        },
      },
    },
  },
  cooking: {
    name: "Cooking",
    type: "crafting",
    industries: { cooking: "Cooking", landbbq: "Barney's BBQ", waterbbq: "Submarine Sizzler", spacebbq: "Galactic Grill" },
    image: "/skills/cooking.png",
    dataTypes: {
      recipes: {
        path: "item.recipes[*]",
        filter: "recipe.expType == 'Cooking'",
        template: {
          Item: { id: "recipe.id", image: "recipe.image", name: "recipe.name" },
          Level: "recipe.level",
          Tier: "recipe.tier",
          Energy: "recipe.energy",
          "Craft Time": "recipe.craftingTime",
          Exp: "recipe.exp",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "recipe.exp",
            energy: "recipe.energy",
          },
          Recipe: {
            ingredients: "recipe.ingredients.map(ing => ({image: ing.image, name: ing.name, quantity: ing.quantity}))",
          },
          Industry: "recipe.expCategory",
        },
      },
    },
  },
  forestry: {
    name: "Forestry",
    type: "resource",
    image: "/skills/forestry.png",
    dataTypes: {
      produce: {
        path: "item.produce[*]",
        filter: "produce.expType == 'forestry'",
        template: {
          Item: { id: "item.id", image: "item.image", name: "item.name" },
          Level: "produce.level",
          Tier: "produce.tier",
          "Energy Per Cut": "produce.energy",
          "Grow Time": "produce.growTime",
          Exp: "produce.exp",
          "Exp/Avg Cuts": {
            exp: "produce.exp",
            energyPerCut: "produce.energy",
            formula: "exp / (energyPerCut * 6)",
          },
        },
      },
    },
  },
  woodwork: {
    name: "Woodworking",
    type: "crafting",
    industries: { woodwork: "Woodworking" },
    image: "/skills/woodwork.png",
    dataTypes: {
      recipes: {
        path: "item.recipes[*]",
        filter: "recipe.expType == 'Woodworking'",
        template: {
          Item: { id: "item.id", image: "recipe.image", name: "recipe.name" },
          Level: "recipe.level",
          Tier: "recipe.tier",
          Energy: "recipe.energy",
          "Craft Time": "recipe.craftingTime",
          Exp: "recipe.exp",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "recipe.exp",
            energy: "recipe.energy",
          },
          Recipe: {
            ingredients: "recipe.ingredients.map(ing => ({image: ing.image, name: ing.name, quantity: ing.quantity}))",
          },
        },
      },
    },
  },
  mining: {
    name: "Mining",
    type: "resource",
    image: "/skills/mining.png",
    dataTypes: {
      produce: {
        path: "item.produce[*]",
        filter: "produce.expType == 'mining'",
        template: {
          Item: { id: "item.id", image: "item.image", name: "item.name" },
          Tier: "produce.tier",
          Energy: "produce.energy",
          "Drop Chance": "produce.dropChance",
          "Drop Amount": "produce.dropAmt",
          Exp: "produce.exp",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "produce.exp",
            energy: "produce.energy",
          },
          "Mine Time": "produce.growTime",
        },
      },
    },
  },
  metalworking: {
    name: "Metalworking",
    type: "crafting",
    industries: {
      metalworking: "Metalworking",
    },
    image: "/skills/metalworking.png",
    dataTypes: {
      recipes: {
        path: "item.recipes[*]",
        filter: "recipe.expType == 'Metalworking'",
        template: {
          Item: { id: "recipe.id", image: "recipe.image", name: "recipe.name" },
          Level: "recipe.level",
          Tier: "recipe.tier",
          Energy: "recipe.energy",
          "Craft Time": "recipe.craftingTime",
          Exp: "recipe.exp",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "recipe.exp",
            energy: "recipe.energy",
          },
          Recipe: {
            ingredients: "recipe.ingredients.map(ing => ({image: ing.image, name: ing.name, quantity: ing.quantity}))",
          },
        },
      },
    },
  },
  stoneshaping: {
    name: "Stoneshaping",
    type: "crafting",
    industries: { stoneshaping: "Stoneshaping" },
    image: "/skills/stoneshaping.png",
    dataTypes: {
      recipes: {
        path: "item.recipes[*]",
        filter: "recipe.expType == 'Stoneshaping'",
        template: {
          Item: { id: "recipe.id", image: "recipe.image", name: "recipe.name" },
          Level: "recipe.level",
          Tier: "recipe.tier",
          Energy: "recipe.energy",
          "Craft Time": "recipe.craftingTime",
          Exp: "recipe.exp",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "recipe.exp",
            energy: "recipe.energy",
          },
          Recipe: {
            ingredients: "recipe.ingredients.map(ing => ({image: ing.image, name: ing.name, quantity: ing.quantity}))",
          },
        },
      },
    },
  },
  business: {
    name: "Business",
    type: "crafting",
    industries: {
      business: "business",
      winery: "Winery",
      compost: "Composter",
      shake: "Milkshake Machine",
      juicer: "Shorelime Juicer",
      coffee: "Latte Machine",
      quantum_recombinator: "Quantum Recombinator",
      machine: "The Machine",
      textile_mill: "Textiler",
    },
    image: "/skills/business.png",
    dataTypes: {
      recipes: {
        path: "item.recipes[*]",
        filter: "recipe.expType == 'Business'",
        template: {
          Item: { id: "recipe.id", image: "recipe.image", name: "recipe.name" },
          Level: "recipe.level",
          Tier: "recipe.tier",
          Energy: "recipe.energy",
          "Craft Time": "recipe.craftingTime",
          Exp: "recipe.exp",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "recipe.exp",
            energy: "recipe.energy",
          },
          Recipe: {
            ingredients: "recipe.ingredients.map(ing => ({image: ing.image, name: ing.name, quantity: ing.quantity}))",
          },
          Industry: "recipe.expCategory",
        },
      },
    },
  },
  // Animal Care - Recipes (Crafting)
  petcare_recipes: {
    name: "Animal Care",
    type: "crafting",
    industries: {
      landbbq: "Barney's BBQ",
      waterbbq: "Submarine Sizzler",
      spacebbq: "Galactic Grill",
    },
    image: "/skills/petcare.png",
    dataTypes: {
      recipes: {
        path: "item.recipes[*]",
        filter: "recipe.expType == 'Animal Care'",
        template: {
          Item: { id: "recipe.id", image: "recipe.image", name: "recipe.name" },
          Level: "recipe.level",
          Tier: "recipe.tier",
          Industry: "recipe.expCategory",
          Energy: "recipe.energy",
          "Drop %": "100",
          "Drop Amt": "recipe.quantityProduced",
          Exp: "recipe.exp",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "recipe.exp",
            energy: "recipe.energy",
          },
          Time: "recipe.craftingTime",
          Recipe: {
            ingredients: "recipe.ingredients.map(ing => ({image: ing.image, name: ing.name, quantity: ing.quantity}))",
          },
        },
      },
    },
  },
  // Animal Care - Produce (Resource)
  petcare: {
    name: "Animal Care",
    type: "resource",
    image: "/skills/petcare.png",
    dataTypes: {
      produce: {
        path: "item.produce[*]",
        filter: "produce.expType == 'petcare'",
        template: {
          Item: { id: "item.id", image: "item.image", name: "item.name" },
          Level: "produce.level",
          Tier: "produce.ver",
          Animal: "produce.industry",
          Energy: "produce.energy",
          Exp: "produce.exp",
          Feed: { feedId: "produce.feed", name: "produce.feedName"},
          "Feed Amt": "produce.feedAmt",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "produce.exp",
            energy: "produce.energy",
          },
          Time: "produce.growTime",
          "Drop %": "produce.dropChance",
          "Drop Amt": "produce.dropAmt",
        },
      },
    },
  },
  // Exploration - Recipes (Crafting)
  exploration_recipes: {
    name: "Exploration",
    type: "crafting",
    image: "/skills/exploration.png", 
    industries: { exploration: "Exploration" },
    dataTypes: {
      recipes: {
        path: "item.recipes[*]",
        filter: "recipe.expType == 'Exploration'",
        template: {
          Item: { id: "item.id", image: "recipe.image", name: "recipe.name" },
          Level: "recipe.level",
          Tier: "recipe.tier",
          Energy: "recipe.energy",
          "Craft Time": "recipe.craftingTime",
          Exp: "recipe.exp",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "recipe.exp",
            energy: "recipe.energy",
          },
          Recipe: {
            ingredients: "recipe.ingredients.map(ing => ({image: ing.image, name: ing.name, quantity: ing.quantity}))",
          },
          Industry: "recipe.expCategory",
        },
      },
    },
  },
  // Exploration - Produce (Resource)
  exploration: {
    name: "Exploration",
    type: "resource",
    image: "/skills/exploration.png",
    dataTypes: {
      produce: {
        path: "item.produce[*]",
        filter: "produce.expType == 'exploration'",
        template: {
          Item: { id: "item.id", image: "item.image", name: "item.name" },
          Level: "produce.level",
          Tier: "produce.tier",
          Industry: "produce.industry",
          Energy: "produce.energy",
          "Drop %": "produce.dropChance",
          "Drop Amt": "produce.dropAmt",
          Exp: "produce.exp",
          "Exp/Energy": {
            formula: "exp / energy",
            exp: "produce.exp",
            energy: "produce.energy",
          },
          Time: "produce.growTime",
        },
      },
    },
  },
};